// Accumulating Redux store modules here

import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

import commonSlice from './common/slice';
import authSlice from './auth/slice';
import buildingsSlice from './buildings/slice';
import expensesSlice from './expenses/slice';
import adminSlice from './admin/slice';
import commentsSlice from './comments/slice';
import reportsSlice from './reports/slice';
import managerSlice from './manager/slice';
import tenantSlice from './tenant/slice';

export const store = configureStore({
    reducer: {
        common: commonSlice,
        auth: authSlice,
        buildings: buildingsSlice,
        expenses: expensesSlice,
        admin: adminSlice,
        comments: commentsSlice,
        reports: reportsSlice,
        manager: managerSlice,
        tenant: persistReducer({ key: 'tenantSlice', storage }, tenantSlice),
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
});

export const persistor = persistStore(store);

// For test utils
export const reducer = {
    common: commonSlice,
    auth: authSlice,
    buildings: buildingsSlice,
    expenses: expensesSlice,
    admin: adminSlice,
    comments: commentsSlice,
    reports: reportsSlice,
    manager: managerSlice
};
